'use client'

import { ComponentType, useEffect, useState } from 'react'
import { Schedule } from 'types'
// import PushIcon from 'public/img/ci-icons/pushnachrichten.svg';
// import KalenderIcon from 'public/img/ci-icons/kalender.svg'
import {
  ReloadStatus,
  useScheduleSearch
} from '@/app/schedule-search/useSchedule'
import { ListItem } from '@/components/newSchedule/ListItem'
import { ListItemMobile } from '@/components/newSchedule/ListItemMobile'
import { Progress } from '@/components/ui/progress'

const SUCCESS_ANIMATION_DURATION = 1.5 // seconds

export const List: ComponentType<{
  schedule: Schedule
  style?: 'list' | 'card'
  refreshInterval?: number
}> = ({ schedule, style = 'card', refreshInterval = 10 }) => {
  const { data, error, loading, reloadStatus } = useScheduleSearch({
    schedule,
    refreshInterval,
    successAnimationDelay: SUCCESS_ANIMATION_DURATION
  })
  if (error) {
    console.error(error)
  }
  if (data.length === 0) {
    return null
  }
  const isListStyle = style === 'list'
  return (
    <div
      className={`@container/schedule ${
        isListStyle ? 'divide-y' : 'space-y-1'
      }`}
    >
      {/* {refreshInterval && (
        <LiveReloadIndicator
          interval={refreshInterval}
          reloadStatus={reloadStatus}
        />
      )} */}
      {refreshInterval && (
        <LiveReloadProgressBar
          interval={refreshInterval}
          reloadStatus={reloadStatus}
        />
      )}
      {data.map((game) => (
        <div key={game.id} className="">
          <div className={isListStyle ? '-mx-4' : ''}>
            <ListItem game={game} isLoading={loading} />
            <ListItemMobile game={game} />
          </div>
        </div>
      ))}
    </div>
  )
}

export function LiveReloadProgressBar({
  interval,
  reloadStatus
}: {
  interval: number
  reloadStatus?: ReloadStatus
}): JSX.Element {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    let animationFrameId: number
    let timeoutId: NodeJS.Timeout

    if (reloadStatus === 'loading') {
      const startTime = performance.now()
      const duration = (interval - SUCCESS_ANIMATION_DURATION) * 1000

      const updateProgress = () => {
        const elapsed = performance.now() - startTime
        const newProgress = Math.min(100, (elapsed / duration) * 100)
        setProgress(newProgress)

        if (elapsed < duration) {
          animationFrameId = requestAnimationFrame(updateProgress)
        }
      }

      animationFrameId = requestAnimationFrame(updateProgress)
    } else if (reloadStatus === 'success') {
      setProgress(100)
      const pauseDuration = SUCCESS_ANIMATION_DURATION * 0.3 * 1000
      timeoutId = setTimeout(() => {
        setProgress(0)
      }, pauseDuration)
    } else {
      setProgress(0)
    }

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId)
      }
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [interval, reloadStatus])

  if (reloadStatus === 'idle' || reloadStatus === 'error') {
    return <></>
  }

  return (
    <>
      <Progress value={progress} className="w-full" />
    </>
  )
}

// too fancy
//
// export function LiveReloadIndicator({
//   interval,
//   reloadStatus
// }: {
//   interval: number
//   reloadStatus?: ReloadStatus
// }): JSX.Element {
//   switch (reloadStatus) {
//     case 'loading':
//     case 'success':
//       return (
//         <div className="flex justify-end items-center gap-1">
//           <ReloadIcon
//             interval={interval}
//             reloadStatus={reloadStatus}
//             successDuration={SUCCESS_ANIMATION_DURATION}
//           />
//         </div>
//       )
//     case 'error':
//       return (
//         <div className="flex justify-end items-center gap-1">
//           <ExclamationTriangleIcon className="w-6 h-6 text-red-500" />
//         </div>
//       )
//     case 'idle':
//     default:
//       return (
//         <div className="flex justify-end items-center gap-1">
//           <EyeClosed className="w-6 h-6 text-red-500" />
//         </div>
//       )
//   }
// }

// function ScheduleSearchTableHeader() {
//   return (
//     <div className="hidden md:grid grid-cols-11 py-4 whitespace-nowrap text-sm gap-4">
//       <div className="col-span-3 flex gap-4 pl-4">
//         <div className="flex-1">Datum</div>
//         <div className="flex-1">Staffel</div>
//       </div>
//       <div className="col-span-3 text-end">Heim</div>
//       <div />
//       <div className="col-span-3">Gast</div>
//       <div className="col-span-1"></div>
//     </div>
//   )
// }
